module.exports = __webpack_public_path__ + "logout.d6bff2aa483a9b9a24eeff943efca6b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/logout.svg
// module id = 358
// module chunks = 0